import { Injectable } from '@angular/core';
import { ProjectService } from 'src/app/services/project/project.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ResourceLibraryService {

	constructor(private projectService: ProjectService) { }

	resolveUrl(href: string): string {
		const match = typeof href === 'string' && href.match(/^res:(.*)/);
		if (!match || !match[1]) {
			return undefined;
		}
		const resname = match[1];

		const projectId = this.projectService.activeProject?.project_id;
		if (!projectId) {
			console.warn(`WARNING: resolving URL ${href} without active project`);
			return undefined;
		}
		return `${environment.serverEndpoint}/api/projects/${projectId}/config/resources/${resname}`;
	}
}
